export default __webpack_public_path__ + "static/media/word.43a562a4.png";